import { Routes, Route, Navigate, useNavigate } from 'react-router-dom'
import { AppConstant } from './AppConstant'
import AccessCodeScreen from './flows/Auth/AccessCodeScreen'
import AdminLoginScreen from './flows/Auth/AdminLoginScreen'
import DoctorLoginScreen from './flows/Auth/DoctorLoginScreen'
import StudioSetupScreen from './flows/Auth/StudioSetupScreen'

import CurrentPatientScreen from './flows/Portal/CurrentPatientScreen'
import DoctorProfileScreen from './flows/Portal/DoctorProfileScreen'
import LobbyScreen from './flows/Portal/LobbyScreen'
import NotesScreen from './flows/Portal/NotesScreen'
import PatientDetailScreen from './flows/Portal/PatientDetailScreen'
import PortalLayout from './flows/Portal/PortalLayout'
import ScheduleScreen from './flows/Portal/ScheduleScreen'
import ShopScreen from './flows/Portal/ShopScreen'

export default function AppRoutes() {
  const navigate = useNavigate()

  // const adminToken = localStorage.getItem('admin_token')
  const accessGranted = localStorage.getItem(AppConstant.PORTAL_ACCESS) === 'granted'
  const doctorToken = localStorage.getItem('doctor_token')
  const studioDetails = localStorage.getItem('studio_details')

  return (
    <Routes>
      {/* 1️⃣ ADMIN OTP FLOW (Public) */}
      {/* {!adminToken && (
        <>
          <Route
            path="/admin-login"
            element={
              <AdminLoginScreen/>
            }
          />
          <Route path="*" element={<Navigate to="/admin-login" />} />
        </>
      )} */}

      {/* 0. CLINIC ACCESS CODE (shared code, gates the doctor list) */}
      {!accessGranted && (
        <>
          <Route path="/access-code" element={<AccessCodeScreen />} />
          <Route path="*" element={<Navigate to="/access-code" />} />
        </>
      )}

      {/*  1. DOCTOR LOGIN FLOW (doctor not logged in) */}
      {accessGranted && !doctorToken && (
        <>
          <Route path="/doctor-login" element={<DoctorLoginScreen />} />
          <Route path="*" element={<Navigate to="/doctor-login" />} />
        </>
      )}

      {/* 2 SETUP FLOW (Doctor logged in, but studio NOT set) */}
      {doctorToken && !studioDetails && (
        <>
          <Route path="/setup-studio" element={<StudioSetupScreen />} />
          <Route path="*" element={<Navigate to="/setup-studio" />} />
        </>
      )}

      {/* 4️⃣ PORTAL FLOW (All tokens exist) */}
      {doctorToken && studioDetails && (
        <Route path="/" element={<PortalLayout />}>
          <Route index element={<Navigate to="/current" />} />
          <Route path="current" element={<CurrentPatientScreen />} />
          <Route path="lobby" element={<LobbyScreen />} />
          <Route path="notes" element={<NotesScreen />} />
          <Route path="shop" element={<ShopScreen />} />
          <Route path="schedule" element={<ScheduleScreen />} />
          <Route path="doctor" element={<DoctorProfileScreen />} />
          <Route path="patient-detail/:visitId" element={<PatientDetailScreen />} />
        </Route>
      )}
    </Routes>
  )
}
